var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { creatableOption } from './creatable';
import { isEqual } from 'lodash';
import { isNotNilOrEmpty } from '@pcty/utils';
export var getListItemData = function (filterTyping, id, inputValue, isMulti, listDataArray, persistedInputValue, flattenedOptions, optionsDataArrayWithoutFixed, onCreatedItem, setInputValue, setListDataArray, showOnlySelected, searchKeys) {
    if (showOnlySelected === void 0) { showOnlySelected = false; }
    var inputValueSearchArray = isMulti ? optionsDataArrayWithoutFixed : flattenedOptions;
    // If a persistedInputValue exists, which it will if persistentSearch is true and an item has been selected,
    // make sure to update the listDataArray.
    if (persistedInputValue && listDataArray) {
        var persistedArray = listDataArray.filter(function (opt) { return !opt.creatable; });
        return setListDataArray(persistedArray);
    }
    // this returns all of the options, if the input is empty.
    if ((!inputValue || !inputValue.trim().length) && !isMulti) {
        return setListDataArray(flattenedOptions);
    }
    else if ((!inputValue || !inputValue.trim().length) && isMulti) {
        return setListDataArray(optionsDataArrayWithoutFixed);
    }
    var _inputValue = inputValue.toLowerCase();
    var compareAgainstSearchKeys = function (item) {
        for (var index = 0; index < searchKeys.length; index++) {
            var searchKey = searchKeys[index];
            if (typeof searchKey === 'string') {
                if (isNotNilOrEmpty(item[searchKey]) && item[searchKey].toLowerCase().includes(_inputValue)) {
                    return true;
                }
            }
            else if (Array.isArray(searchKey)) {
                var check = searchKey
                    .reduce(function (accumulator, key) { return __spreadArray(__spreadArray([], accumulator, true), [item[key]], false); }, [])
                    .join(' ')
                    .toLowerCase();
                if (check.includes(_inputValue)) {
                    return true;
                }
            }
        }
        return false;
    };
    var checkInput = function () {
        var retArr = [];
        // this method is dual-purposed to filter by the selected items OR the search text (bad, bad, BAD!! yet we can't change it...yet)
        for (var i = 0; i < inputValueSearchArray.length; i++) {
            if (!inputValueSearchArray[i].header &&
                ((searchKeys.length === 1 &&
                    searchKeys[0] === 'label' &&
                    inputValueSearchArray[i].label.toLowerCase().includes(_inputValue)) ||
                    (searchKeys.length === 1 &&
                        searchKeys[0] !== 'label' &&
                        compareAgainstSearchKeys(inputValueSearchArray[i].value)) ||
                    (searchKeys.length > 1 && compareAgainstSearchKeys(inputValueSearchArray[i].value)))) {
                retArr.push(inputValueSearchArray[i]);
            }
        }
        // show the entire list if !showOnlySelected and !isMulti and the list was filtered by a selected-item
        if (!showOnlySelected &&
            retArr.length === 1 &&
            retArr[0].label.toLowerCase() === _inputValue &&
            retArr[0].selected) {
            return inputValueSearchArray;
        }
        return retArr;
    };
    // check if its not a header, and either the label, or the preferred first name matches the input
    var retOptions = filterTyping ? checkInput() : inputValueSearchArray;
    // if on filter there are no matching options
    if (retOptions.length < 1) {
        retOptions = [
            {
                empty: true,
                label: 'No Results Found',
                value: 'No Results Found',
            },
        ];
    }
    // add the creatable row if it is needed only when searchable
    retOptions = __spreadArray(__spreadArray([], creatableOption(id, inputValue, onCreatedItem, retOptions, setInputValue), true), retOptions, true);
    setListDataArray(retOptions);
};
export var resetFocusRow = function (_a) {
    var listDataArray = _a.listDataArray, setFocusedRow = _a.setFocusedRow, value = _a.value, filterTyping = _a.filterTyping;
    if (filterTyping)
        return;
    // resetting focus row here when enter is pressed
    if (value === undefined || (Array.isArray(value) && !value[0])) {
        setFocusedRow(null);
    }
    else {
        var obj_1 = Array.isArray(value) ? value[0] : value;
        var newIndex = listDataArray.findIndex(function (x) { return isEqual(x, obj_1); });
        setFocusedRow(newIndex);
    }
};
export var handleScrollToItemOnOpen = function (_a) {
    var gridListRef = _a.gridListRef, listDataArray = _a.listDataArray, listRef = _a.listRef, setFocusedRow = _a.setFocusedRow, value = _a.value, __isEmployee = _a.__isEmployee;
    var rowIndex = 0;
    if ((value && value.label) || (Array.isArray(value) && value[0])) {
        var val_1 = value.label ? value : value[0];
        rowIndex = listDataArray.findIndex(function (x) { return isEqual(x, val_1); });
        setFocusedRow(rowIndex);
    }
    var scrollRef = __isEmployee ? gridListRef : listRef;
    if (scrollRef && scrollRef.current) {
        scrollRef.current.scrollToItem(__isEmployee ? { row: 1, rowIndex: rowIndex } : rowIndex);
    }
};
export var handleListScroll = function (e, id, setScrollLoading, scrollLoading, scrollingListInnerRef, scrollingListOuterRef, scrolledToBottomItemBuffer, rowHeight, onScrolledToBottom) {
    var _a;
    if (!scrollingListInnerRef || !scrollingListInnerRef.current || !onScrolledToBottom)
        return;
    var scrollToBottomOffset = scrolledToBottomItemBuffer * rowHeight;
    var scrollEventDistance = e.scrollOffset ? e.scrollOffset : e.scrollTop;
    var scrollOffset = scrollEventDistance + ((_a = scrollingListOuterRef.current) === null || _a === void 0 ? void 0 : _a.getClientRects()[0].height);
    var scrolledToBottomMinusOffset = scrollingListInnerRef.current.getClientRects()[0].height - scrollToBottomOffset;
    // this ensures the scroll to bottom will only fire once until you either scroll up or more info is loaded
    if (scrollLoading && scrollOffset < scrolledToBottomMinusOffset) {
        setScrollLoading(false);
    }
    else if (!scrollLoading && scrollOffset >= scrolledToBottomMinusOffset) {
        onScrolledToBottom({ id: id });
        setScrollLoading(true);
    }
};
